import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { CreditTypesEnum } from '../../components/shared/BookingCheckout';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { GetCreditCardResponseDto } from './dto/response/get-credit-card-response.dto';
import { GetCreditBalanceResponseDto } from './dto/response/get-credit-balance-response.dto';

const USERS_PATH = HttpPathsEnum.USERS;
const CUSTOMER_PATH = HttpPathsEnum.COMPANY;

class CreditApi {
  public async getCreditsBalances(creditBy: CreditTypesEnum) {
    switch (creditBy) {
      case CreditTypesEnum.COMPANY:
        return this.getCompanyCreditBalances();
      case CreditTypesEnum.USER:
        return this.getUserCreditBalances();
    }
  }

  public async getCompanyCreditBalances() {
    const request: HttpRequest = {
      url: `${CUSTOMER_PATH}/credit/balances`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCreditBalanceResponseDto[]>(
      request,
      GetCreditBalanceResponseDto
    );
  }

  public async getUserCreditBalances() {
    const request: HttpRequest = {
      url: `${USERS_PATH}/credit/balances`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCreditBalanceResponseDto[]>(
      request,
      GetCreditBalanceResponseDto
    );
  }

  public async getCreditCards() {
    const request: HttpRequest = {
      url: `${USERS_PATH}/credit-cards/my-cards`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCreditCardResponseDto[]>(
      request,
      GetCreditCardResponseDto
    );
  }

  public async removeCreditCard(cardId: number) {
    const request: HttpRequest = {
      url: `${USERS_PATH}/credit-cards/${cardId}`,
      method: RequestType.DELETE,
    };

    return await AppHttpClient.exec<any, GetCreditCardResponseDto>(
      request,
      GetCreditBalanceResponseDto
    );
  }
}

export default new CreditApi();
